import { useAtom } from 'jotai'

import { showRangeCalendarStore } from 'src/stores'

export const useShowRangeCalendarStore = () => {
  const [showRangeCalendarStoreValue, setShowRangeCalendarStoreValue] = useAtom(
    showRangeCalendarStore.state
  )

  return {
    showRangeCalendarStoreValue,
    setShowRangeCalendarStoreValue,
  }
}
